<template>
  <div class="statistics-list">
    <div class="searchbox">
      <div class="item">
        <span>回访时间</span>
        <el-date-picker
          v-model="visit_time"
          type="daterange"
          range-separator="到"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="margin-left: 12px"
          value-format="yyyy-MM-dd"
          size="small"
          @change="search"
          clearable
        ></el-date-picker>
      </div>

      <div class="item">
        <span>回访人员状态</span>
        <div style="padding-top: 3px; margin-left: 10px">
          <el-radio-group v-model="user_status" @change="search">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">锁定</el-radio>
            <el-radio :label="2">删除</el-radio>
          </el-radio-group>
        </div>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 12px"
          @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <div class="top">
      <div class="item">
        <span>回访总量：</span>
        <span>{{ visit_info.total_num }}</span>
      </div>
      <div class="item">
        <span>回访医生数：</span>
        <span>{{ visit_info.doctor_num }}</span>
      </div>
      <div class="item">
        <span>回访患者数：</span>
        <span>{{ visit_info.patient_num }}</span>
      </div>
      <div class="item">
        <span>回访处方数：</span>
        <span>{{ visit_info.pre_num }}</span>
      </div>
      <div class="item">
        <span>回访咨询数：</span>
        <span>{{ visit_info.consult_num }}</span>
      </div>
      <div class="item">
        <span>其他回访数：</span>
        <span>{{ visit_info.other_num }}</span>
      </div>
      <el-button
        type="primary"
        @click="exportExcel"
        style="width: 92px"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('1318') : false
        "
        >导出</el-button
      >
    </div>
    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ background: '#F5F5F5' }"
        @sort-change="changeOrder"
      >
        <el-table-column label="回访人员" prop="visit_name"></el-table-column>
        <el-table-column
          label="总回访量"
          prop="total_num"
          sortable="custom"
        ></el-table-column>
        <el-table-column label="回访医生数" prop="doctor_num"></el-table-column>
        <el-table-column
          label="回访患者数"
          prop="patient_num"
        ></el-table-column>
        <el-table-column label="回访处方数" prop="pre_num"></el-table-column>
        <el-table-column
          label="回访咨询数"
          prop="consult_num"
        ></el-table-column>
        <el-table-column label="其他回访数" prop="other_num"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="toStatisticsDetail(scope.row.visit_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1319') : false
              "
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-top: 24px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="totalNum"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      visit_time: [],
      user_status: 1,
      order_key: "",
      order_key: "",
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      loading: false,
      visit_info: {
        total_num: "",
        doctor_num: "",
        patient_num: "",
        pre_num: "",
        consult_num: "",
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  activated() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.visit_time = [start, end];
    },
    //查询列表
    getList() {
      let data = {
        order_key: this.order_key,
        order_value: this.order_value,
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_status: this.user_status,
        visit_start_time: this.visit_time ? this.visit_time[0] : "",
        visit_end_time: this.visit_time ? this.visit_time[1] : "",
      };
      this.loading = true;
      this.axios
        .post("platform/Clientreview/getVisitCountData", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.visit_info = res.data.visit_info;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    //导出
    exportExcel() {
      let data = {
        order_key: this.order_key,
        order_value: this.order_value,
        user_status: this.user_status,
        visit_start_time: this.visit_time ? this.visit_time[0] : "",
        visit_end_time: this.visit_time ? this.visit_time[1] : "",
      };
      this.axios
        .post("platform/Clientreview/exportVisitCountData", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
        });
    },

    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      //升序
      if (order == "ascending") {
        this.order_key = value.prop;
        this.order_value = "asc";
      }
      //降序
      if (order == "descending") {
        this.order_key = value.prop;
        this.order_value = "desc";
      }
      if (!order) {
        this.order_key = "";
        this.order_value = "";
      }
      this.getList();
    },
    //查看回访详情
    toStatisticsDetail(visit_id) {
      this.$router.push({
        path: "statisticsDetail",
        query: {
          visit_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  .item {
    font-size: 16px;
    font-weight: bold;
    margin-right: 10px;
  }
}

.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
}

.title {
  font-size: 16px;
}
p {
  margin: 5px 0;
}
</style>
